import { globalAction$, valibot$, z, zod$ } from "@builder.io/qwik-city";
import { EnvKey } from "../utils";
import { getProfileGenerator } from "../ai-profile-generator";
import { CoachSelect } from "../schemas";
import { getCoachDetails, getCoachProfile } from "../coach.db";

export const FieldInfoSchema = z.object({
  label: z.string().optional(),
  helpText: z.string().optional(),
  currentValue: z.string().optional(),
  maxLength: z.number().optional(),
});

export type FieldInfo = z.infer<typeof FieldInfoSchema>;

export interface FilledField {
  content: string;
}

export const useAiFillField = globalAction$(
  async (fieldInfo, { env, sharedMap }) => {
    const profileGenerator = getProfileGenerator(
      env.get(EnvKey.OPENAI_API_KEY)!,
      env.get(EnvKey.JINA_API_TOKEN)!,
      env.get(EnvKey.OPENAI_BASE_URL)!,
    );
    const coach = sharedMap.get("coach") as CoachSelect;

    if (!coach) {
      throw new Error("Coach not found");
    }

    const existingProfile = coach.profileId
      ? await getCoachProfile(coach.profileId)
      : undefined;
    const existingDetails = coach.coachDetailsId
      ? await getCoachDetails(coach.coachDetailsId)
      : undefined;

    const content = await profileGenerator.generateFieldContent(
      fieldInfo,
      coach,
      existingProfile,
      existingDetails,
    );

    return {
      content,
    };
  },
  zod$(FieldInfoSchema),
);
